import { useMutation, useQueryClient } from '@tanstack/react-query';

type Props = {
  checked: boolean;
  /** Query key prefix of the list to refetch afterwards. */
  listKey: string;
  toggle: (next: boolean) => Promise<unknown>;
  disabled?: boolean;
};

/** Checkbox cell persisting its new value immediately, then refetching the list. */
export const ToggleCell = ({ checked, listKey, toggle, disabled }: Props) => {
  const qc = useQueryClient();
  const mutation = useMutation({
    mutationFn: toggle,
    onSuccess: () => qc.invalidateQueries({ queryKey: [listKey] }),
    onError: () => window.alert('Не удалось сохранить изменение'),
  });

  return (
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled || mutation.isPending}
      onChange={(e) => mutation.mutate(e.target.checked)}
    />
  );
};
